import { IntlFormatters } from 'react-intl';
import { isString, map } from 'lodash';

import { squigglyTemplates } from '../constants/squigglyTemplates';
import { getSquigglyTemplateIds } from '../getSquigglyTemplateIds/getSquigglyTemplateIds';
import { getSquigglyProvisioning } from '../getSquigglyProvisioning/getSquigglyProvisioning';
import { getSquigglyName } from '../getSquigglyName/getSquigglyName';

/**
 * returns all squigglies templates with their id, name and provisioning
 * @param squigglies either the list of ids eg `['system.url.chatUrl', 'system.url.insuranceUrl']` or
 * the squigglies key eg `'hub'`
 * @param formatMessage from `useIntl`
 * @category Getters
 * @category Squiggly
 * @returns
 */
export const getSquigglyTemplates = (
  squigglies: keyof typeof squigglyTemplates | string[] | string,
  formatMessage: IntlFormatters['formatMessage'],
) => {
  let ids = squigglies;
  if (isString(squigglies)) {
    ids = getSquigglyTemplateIds(squigglies as keyof typeof squigglyTemplates);
  }
  return map(ids, (id) => ({
    id,
    name: getSquigglyName(id, formatMessage),
    provisioning: getSquigglyProvisioning(id),
  }));
};
